<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    optionsusers: {
      type: Object,
      default: () => [],
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
    textlength: {
      type: Number,
      default: 1000,
    },
    showCloseButton: {
      type: Boolean,
      default: false,
    },
    showSelectedOption: {
      type: String,
      default: 'Y',
    },
    showStyling: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function(newValue) {
        this.selectedOption = newValue
      },
    },
  },
  mounted() {
    this.selectedOption = this.value
    document.body.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        this.isDefault = true
        this.isOpen = false
      }
    })
  },
  methods: {
    onSearchSubmit(selectedValue) {
      this.$emit('searchSubmit', selectedValue)
    },
    closeButton() {
      this.$emit('closeButton')
    },
  },
}
</script>

<template>
  <b-row>
    <b-col v-if="showSelectedOption === 'Y'" md="2" class="mr-0 pr-0">
      <select
        v-if="showSelectedOption === 'Y'"
        slot="prepend"
        v-model="selectedOption"
        class="form-control w-100 selectbg borderRadiusLeft"
        v-bind="$attrs"
        v-on="$listeners"
        @change="$emit('update', $event.target.value)"
      >
        <option
          v-for="(option, name) in optionsusers"
          :key="option.id"
          :value="option"
          >{{ name }}</option
        >
      </select>
    </b-col>
    <b-col
      md="5"
      class="mx-0"
      :class="showSelectedOption === 'Y' ? 'px-0' : ''"
    >
      <b-form-input
        v-model="search"
        class="rounded-0"
        placeholder="Type to Search"
        :maxlength="textlength"
        @keyup.enter="onSearchSubmit({ selectedOption, search })"
      />
    </b-col>
    <b-col md="2" class="ml-1 pl-1">
      <BaseEButton
        pre-icon="search"
        @click="onSearchSubmit({ selectedOption, search })"
      >
        Search
      </BaseEButton>
    </b-col>
  </b-row>
</template>

<style lang="scss" scoped>
@import '@design';
.searchModal {
  padding: 5px;
  opacity: 1;
}
.borderRadiusLeft {
  border-top-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 5px;
}
.borderRadiusRight {
  border-top-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 0;
}

.btnDarkblue {
  background-color: #00264c;
}
</style>
